import { Reveal, SectionHead } from "@/lib/motion";
import MessageForm from "@/components/MessageForm";
import { ShieldCheck, Clock, MessageSquare } from "lucide-react";

const NOTES = [
  { icon: Clock, title: "Response time", desc: "Every enquiry is reviewed personally. Expect a reply within one business day — faster in filing season." },
  { icon: ShieldCheck, title: "Sensitive documents", desc: "Please don't email W-2s, Social Security numbers or account numbers. Those move through the secure client portal once we engage." },
  { icon: MessageSquare, title: "Not sure what to ask?", desc: "Describe your situation in plain words. Figuring out the right questions is our job, not yours." },
];

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pt-20">
      <section className="border-b border-steel-border">
        <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
          <SectionHead
            overline="Contact"
            title="Tell us what's going on."
            copy="A notice, a new business, three unfiled years, or a simple W-2 — start the conversation here."
          />
        </div>
      </section>

      <section className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 py-24 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-7">
          <Reveal>
            <MessageForm
              heading="Send a message"
              subheading="General questions, notice reviews, prior years — anything tax. It goes straight to Jared."
            />
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <div className="space-y-8 lg:sticky lg:top-32">
            {NOTES.map((n, i) => (
              <Reveal key={n.title} delay={i * 0.08}>
                <div className="flex gap-5 border border-steel-border bg-steel-surface p-7">
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center border border-steel-border">
                    <n.icon className="h-5 w-5 text-steel-brass" />
                  </div>
                  <div>
                    <h3 className="font-display text-lg font-medium text-steel-text">{n.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-steel-secondary">{n.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
